import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setLabData } from "../../reducers/Lab/labform.reducer";
export const labEntrySchema = Joi.object({
  test_name: Joi.string().trim().required().messages({
    "string.empty": "Test Name is required.",
  }),
  price: Joi.number().required().messages({
    "number.base": "Price is required",
  }),
  details: Joi.string().optional().allow(""),
});

export function useLabForm({ existingStatus }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(existingStatus === 2 ? 0 : 1);
  const [Id, setId] = useState("");
  const [Name, setName] = useState("");
  const [Price, setPrice] = useState("");
  const [Details, setDetails] = useState("");

  const handleDeleteId = useCallback(
    (row) => {
      setId(row.id);
      setName(row.test_name);
      setPrice(row.price);
      setDetails(row.details);
    },
    [Id, Name, Details, Price]
  );
  const labEntry = useCallback(
    async ({ test_name, price, details }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
        // const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
        const { data } = await apiPost({
          url: Urls.labAdd(),
          data: {
            test_name: test_name,
            details: details,
            price: price,
            status: status_Val,
            insert_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (size(data.id) === 36) {
          enqueueSnackbar("Lab Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const labUpdate = useCallback(
    async ({ id, test_name, price, details }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.labUpdate(),
          data: {
            id: id,
            test_name: test_name,
            price: price,
            details: details,
            status: status_Val,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("Lab Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const labDelete = useCallback(async () => {
    //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
    try {
      dispatch(showPageLoader());
      const { data } = await apiPost({
        url: Urls.labUpdate(),
        data: {
          id: Id,
          test_name: Name,
          price: Price,
          details: Details,
          status: 2,
          update_by: "",
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data.id) === 36) {
        enqueueSnackbar("Lab Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, [status, Id, Name, Price, Details]);

  const getLabbyId = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.getlabDatabyId(),
          data: {
            id: id,
          },
        });

        dispatch(setLabData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    labEntrySchema,
    handleStatusComboChange,
    labEntry,
    labUpdate,
    getLabbyId,
    labDelete,
    handleDeleteId,
  };
}
